export const SectionHeading = ({ eyebrow, title, description, align = "left", light = false }) => {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2
        className={`mt-4 font-display font-bold text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight ${
          light ? "text-white" : "text-[#14324A]"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-white/75" : "text-[#4B6B86]"}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
